export default function isAuthenticated() {
  // Check whether the current time is past the
  // access token's expiry time
  let expiresAt = JSON.parse(localStorage.getItem('expires_at')!)
  return new Date().getTime() < expiresAt
}

export const AUTH_CONFIG = {
  domain: 'vaulture.auth0.com',
  clientId: 'h8qukYFLWA7Tba2Yvcn4j1eKHmLYcCSy',
  // callbackUrl: 'http://localhost:3000/callback',
  container: 'auth0-login-container',
}
